import { Component } from '@angular/core';

@Component({
  selector: 'app-quotes-demo',
  templateUrl: './quotes-demo.component.html',
})
export class QuotesDemoComponent {}
